import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { PaymentRequestsOverview } from './types';

export default (makeCall: MakeCall) => (
  tenancyUUIDs: string[],
): Promise<{ data: { data: PaymentRequestsOverview[] }; status: number }> =>
  makeCall<{ data: PaymentRequestsOverview[] }>(
    'GET',
    '/api/v1/payments/overview',
    {
      query: {
        tenancy: tenancyUUIDs.join(','),
      },
    },
  );
